module.exports = __webpack_public_path__ + "static/media/Airtel.94a46712.svg";